import React from 'react'
import { PersonBlock, ResponsiveTableRow } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { DmcResponsiveCheckboxTable } from '../../common/DmcResponsiveTable'
import CommonPerson from '../../common/CommonPerson'
import { CtrLink } from '../../app/Links'
import { capitalizeFirstLetter } from '../../../util/StringUtil'

export default function UserOrdinancesResponsiveTable({ completedOrdinances, handleSelectedOrdinances }) {
  const [t] = useTranslation()

  if (!completedOrdinances || completedOrdinances.length === 0) {
    return null
  }
  const qualifyingDetails = (qe) => {
    if (qe) {
      const { type, date, place } = qe
      return (
        <>
          {`${capitalizeFirstLetter(type)}: ${date || ''}`}
          <br />
          {` ${place || ''}`}
        </>
      )
    }
    return null
  }

  const ordinanceTypeCtr = (ordinance) => {
    return (
      <>
        {t(`ctr.ordinanceType.${ordinance.type}`, ordinance.type)}
        {' • '}
        <CtrLink ctrId={ordinance.rtoId} />
      </>
    )
  }

  const ordinanceDetails = (ordinance) => {
    const hfu = ordinance.hiddenFromUser ? t('yes', 'Yes') : t('no', 'No')
    const hco = ordinance.hideCompletedOrdinances ? t('yes', 'Yes') : t('no', 'No')
    return (
      <>
        {`${ordinance.performedDate} • ${ordinance.temple}`}
        <br />
        {`${t('ordinances.user.hiddenFromUser', 'Hidden from User')}: ${hfu}`}
        <br />
        {`${t('accessControl.hideCompletedOrds', 'Hide Completed Ordinances')}: ${hco}`}
      </>
    )
  }

  const sealingPersons = (persons) => {
    const father = persons.FATHER
    const mother = persons.MOTHER
    const spouse = persons.SPOUSE
    return (
      <>
        {father && <CommonPerson name={father.fullName} gender={father.gender} personId={father.personId} />}
        {mother && <CommonPerson name={mother.fullName} gender={mother.gender} personId={mother.personId} />}
        {spouse && <CommonPerson name={spouse.fullName} gender={spouse.gender} personId={spouse.personId} />}
      </>
    )
  }

  return (
    <DmcResponsiveCheckboxTable
      id="userCompletedOrdinancesTable"
      atSizeColumns={{
        default: {
          labels: [
            `${t('person.label', 'Person')}, ${t('ordinances.label', 'Ordinances')} & ${t('sealingLbl', 'Sealing')}`,
          ],
        },
        sm: {
          labels: [
            `${t('person.label', 'Person')} & Qualifying Event`,
            `${t('ordinances.label', 'Ordinances')} & ${t('sealingLbl', 'Sealing')}`,
          ],
          columnWidths: [5, 7],
        },
        xl: {
          labels: [
            `${t('person.label', 'Person')} & Qualifying Event`,
            `${t('ordinances.label', 'Ordinances')}`,
            `${t('sealingLbl', 'Sealing')}`,
          ],
          columnWidths: [5, 4, 3],
        },
      }}
      totalColumnCount={3}
      onSelectionChange={handleSelectedOrdinances}
    >
      {completedOrdinances.map((row) => {
        const ordinance = row
        const principal = ordinance.persons.PRINCIPAL
        const qualifyingEvent = ordinance.qualifyingEvent
        return (
          <ResponsiveTableRow
            key={`${principal.personId}*${ordinance.type}*${ordinance.rtoId}`}
            name={`${principal.personId}*${ordinance.type}*${ordinance.rtoId}*${ordinance.hiddenFromUser}`}
            column1={
              <CommonPerson
                name={principal.fullName}
                details={qualifyingDetails(qualifyingEvent)}
                gender={principal.gender}
                personId={principal.personId}
              />
            }
            column2={
              // Using a PersonBlock to display Ordinances to mantain same style
              <PersonBlock size="sm" name={ordinanceTypeCtr(ordinance)} details={ordinanceDetails(ordinance)} />
            }
            column3={<>{sealingPersons(row.persons)}</>}
          />
        )
      })}
    </DmcResponsiveCheckboxTable>
  )
}
